import { SET_PREVIOUS_PAGE } from '../actions'

const INITIAL_STATE = {
    previous: null,
}


function PageHistoryReducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case SET_PREVIOUS_PAGE:
            return {
                ...state,
                previous: action.payload,
            }
        default:
            return state
    }
}

export default PageHistoryReducer



// WEBPACK FOOTER //
// ./src/reducers/pageHistory.js